import Vue from 'vue'
import store from '@/store'
import {mapGetters, mapActions}    from 'vuex'

var moment   = require('moment');

moment.locale();

export default {
	data () {
		return {
			descripClima:'',
			temperatura:0,
			iconClima:null,
			tareas_programadas:[],
      countTareas:0,
		}
	},
	computed: {
		...mapGetters('Carrito', ['getCarrito']),
		...mapGetters('login', ['getCCNNUsuario','getLogeado', 'getEscuela','getEstatusLlamada','getTareas','getNuevosProspectos']),
    ...mapGetters('tema', ['getTema']),
    ...mapGetters('Carrito',['getCarrito']),
	},

	methods: {
    ...mapActions('login', ['salirLogin','cambiarEscuela','abrirProspecto','cambiarEstatusLlamada','addTareas','traerProspectosNuevos']),

    // getComisionesVendedora( ){

    //   if( this.getCCNNUsuario.idpuesto == 18 ){


    //     this.overlay = true;
    //     const payload = {
    //       fecha     : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    //       id_usuario: this.getCCNNUsuario.iderp,
    //     }

    //     this.$http.post("encargadas_comisiones.get.comisionesestatus", payload).then((response) => {

    //       let estatus = 0

    //       if ( response.data.length > 0){

    //         estatus = response.data[0].estatus

    //       } else {

    //         estatus = 0

    //       }

    //       if( [0,4].includes( estatus ) ){

    //         this.paramsComisiones.estatus = true

    //       }
    //     }).catch((error) => {
    //       // INdicamos que hay un error en el back
    //       if (error.body.message) {
    //         this.error = error.body.message;
    //       } else {
    //         this.error = error.body;
    //       }
    //       this.errorBack = true;
    //       this.overlay = false;
    //       this.dialogError = true;
    //     });

    //   }
    // },



    // getTicketsPorUsuario( ){

    //   this.overlay = true;

    //   if( this.getLogeado ){
    //     this.$http.get("tickets.usuario.erp/" + this.getCCNNUsuario.iderp ).then((response) => {

    //       if( response.data.length > 5 && ![334,31,28,1932].includes( this.getCCNNUsuario.iderp ) ){

    //         this.paramsTickets.estatus = true

    //       }


    //     }).catch((error) => {

    //       console.log( error )
    //       // INdicamos que hay un error en el back
    //       if (error.data.message) {
    //         this.error = error.data;
    //       } else {
    //         this.error = error.data;
    //       }
    //       this.errorBack = true;
    //       this.overlay = false;
    //       this.dialogError = true;
    //     });
    //   }


    // }

  }
}
